import React from 'react';
import type { TrainingInsights } from './types';
import type { InsightSectionId } from './insightSections';
import ObjFaqHandlingSection from './sections/ObjFaqHandlingSection';
import LandmineHandlingSection from './sections/LandmineHandlingSection';
import CompetitorHandlingSection from './sections/CompetitorHandlingSection';
import PlaybookCoverageSection from './sections/PlaybookCoverageSection';
import KbItemProgressionSection from './sections/KbItemProgressionSection';
import ToneAnalysisSection from './sections/ToneAnalysisSection';
import StageDisciplineSection from './sections/StageDisciplineSection';
import AgendaCoverageSection from './sections/AgendaCoverageSection';
import ClosingEffectivenessSection from './sections/ClosingEffectivenessSection';
import ConversationalDynamicsSection from './sections/ConversationalDynamicsSection';
import DiscoveryQualitySection from './sections/DiscoveryQualitySection';

/** The section component for one registry id, fed from this session's insights. */
const renderInsightSection = (
  id: InsightSectionId,
  insights: TrainingInsights,
  onNavigateToTimestamp?: (timestampIso: string) => void,
): React.ReactNode => {
  switch (id) {
    case 'discovery': return <DiscoveryQualitySection data={insights?.discoveryQuality} />;
    case 'concerns': return <AgendaCoverageSection data={insights?.agendaCoverage} />;
    case 'closing': return <ClosingEffectivenessSection data={insights?.closingEffectiveness} />;
    case 'stages': return <StageDisciplineSection data={insights?.stageDiscipline} />;
    case 'delivery': return <ConversationalDynamicsSection data={insights?.conversationalDynamics} />;
    case 'playbook':
      return insights?.playbookCoverage ? <PlaybookCoverageSection data={insights.playbookCoverage} /> : null;
    case 'objections':
      return <ObjFaqHandlingSection data={insights?.objectionFaqHandling} onNavigateToTimestamp={onNavigateToTimestamp} />;
    case 'landmines':
      return <LandmineHandlingSection data={insights?.landmineHandling} onNavigateToTimestamp={onNavigateToTimestamp} />;
    case 'competitors':
      return <CompetitorHandlingSection data={insights?.competitorHandling} onNavigateToTimestamp={onNavigateToTimestamp} />;
    case 'kbItems':
      return insights?.salesIntelligence ? <KbItemProgressionSection data={insights.salesIntelligence} /> : null;
    case 'tone':
      return insights?.toneAnalysis ? <ToneAnalysisSection data={insights.toneAnalysis} /> : null;
    default: return null;
  }
};

export default renderInsightSection;
